import React from 'react'
import styled from 'styled-components'
import { WidgetProps } from '@rjsf/utils'

import { FeedbotSelect } from '../../../../../selects'
import { useSelectPortalRef } from '../../../../../../SelectPortalProvider'

export const CustomValidationOperatorWidget: React.FC<WidgetProps> = ({
  value: operatorId,
  onChange
}) => {
  const portalRef = useSelectPortalRef()

  const defaultValue = { value: 'and', label: 'AND' }
  const options = [defaultValue, { value: 'or', label: 'OR' }]
  const value = { value: operatorId, label: operatorId?.toUpperCase() }

  return (
    <Dropdown>
      <FeedbotSelect
        value={value}
        options={options}
        openMenuOnFocus={false}
        defaultValue={defaultValue}
        menuPortalTarget={portalRef}
        placeholder="Enter existing operator"
        onChange={option => {
          if (!option) {
            return
          }

          onChange(option.value)
        }}
      />
    </Dropdown>
  )
}

const Dropdown = styled.span`
  min-width: 100px;
  max-width: 100px;
  width: calc(80% - 26px);
  margin: auto auto auto -120px;
`
